module.exports = __webpack_public_path__ + "img/一键美颜--多种款式.574ec15f.png";